
export default {
  props: {
    product: { type: Object, default: () => {} },
    selectedVariant: { type: Object, default: () => {} },
    campaigns: { type: Array, default: () => [] },
    maxDiscount: { type: [Number, String], default: 0 },
    productImages: { type: Array, default: () => [] },
  },

  head() {
    if (!this.product) {
      return null;
    }

    return {
      script: [
        {
          hid: `jsonld-${this.product.handle}`,
          type: "application/ld+json",
          json: {
            "@context": "http://schema.org",
            "@type": "Product",
            name: this.product.title,
            image: this.productImages.map(x => x.src),
            description: this.product.description,
            sku: this.selectedVariant.sku,

            ...(this.product.brand_list && {
              brand: {
                "@type": "Brand",
                name: this.product.brand_list,
              },
            }),

            ...(this.ratingCount > 0 && {
              review: this.reviews.slice(0, 3).map(review => ({
                "@type": "Review",
                reviewRating: {
                  "@type": "Rating",
                  ratingValue: review.score,
                },
                author: {
                  "@type": "Person",
                  name: review.user.display_name,
                },
                reviewBody: review.content,
              })),

              aggregateRating: {
                "@type": "AggregateRating",
                ratingValue: this.bottomline.average_score,
                ratingCount: this.bottomline.total_review,
              },
            }),

            ...(this.campaigns.length && {
              offers: {
                "@type": "AggregateOffer",
                offerCount: this.campaigns.length,
                lowPrice: this.selectedVariant.price,
                highPrice: this.campaigns.length
                  ? this.selectedVariant.price * (1 - this.maxDiscount / 100)
                  : this.selectedVariant.price,
                priceCurrency: "AUD",
              },
            }),

            // Either review or offers should be present
            ...(this.ratingCount <= 0 && {
              offers: {
                "@type": "Offer",
                price: this.selectedVariant.price,
                priceCurrency: "AUD",
                availability: "http://schema.org/InStock",
                priceValidUntil: `${new Date().getFullYear()}-12-31`,
              },
            }),

            // adding return policy here since GMC is not able to ammend the 14 days return policy
            // https://schema.org/MerchantReturnPolicy
            hasMerchantReturnPolicy: {
              "@type": "MerchantReturnPolicy",
              applicableCountry: "AU",
              returnPolicyCountry: "AU",
              returnPolicyCategory:
                "https://schema.org/MerchantReturnNotPermitted",
            },
          },
        },
      ],
    };
  },

  created() {
    this.bottomline = this.$store.state.pdp.bottomline;
    this.reviews = this.$store.state.pdp.reviews ?? [];
    this.ratingCount = this.bottomline?.total_review ?? 0;
  },

  render() {
    return null;
  },
};
